import { Link as RouterLink } from "@tanstack/react-router";
// Components
import { MergeDraftDialog } from "../../components/MergeDraftDialog";
// MUI
import Typography from "@mui/material/Typography";
import Stack from "@mui/material/Stack";
import Button from "@mui/material/Button";

export function RequestListHeader({
  status,
  canMerge,
  selectedRows,
  setSelectedRows,
}) {
  let heading = "Draft Requests";
  if (status === "submitted") {
    heading = "Submitted Requests";
  } else if (status === "approvals") {
    heading = "Approvals";
  }

  return (
    <Stack
      direction="row"
      spacing={2}
      sx={{
        justifyContent: "space-between",
        alignItems: "center",
        pb: 1,
      }}
    >
      <Typography variant="h5">{heading}</Typography>

      <Stack direction="row" spacing={2}>
        {status !== "approvals" && (
          <Button variant="outlined" component={RouterLink} to="/request">
            New Request
          </Button>
        )}
        {canMerge && (
          <MergeDraftDialog
            entityLabel="Requests"
            selectedRows={selectedRows}
            setSelectedRows={setSelectedRows}
            disabled={false}
          />
        )}
      </Stack>
    </Stack>
  );
}
